import { QRFC } from "./QRFC";

export class QDeleteUsersRFC extends QRFC {
  constructor() {
    super();
  }

  InitDeleteUsersRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qdeleteusers";
  }

  SetParams(orgName, user, delUsers) {
    this.AddEncodedParameter("org", orgName);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("users", delUsers);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    var success = false;
    if (r != "failure") success = true;

    callBackObj.DeleteUsersResult(success);
  }
}
